import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';

import { Avatar, Box, Typography } from '@mui/material';

import avatar from '../../../../../../assets/images/avatar1.png';

const Profile = ({ className, ...rest }) => {
  const user = {
    name: 'DR. John Smith MD.',
    bio: 'Medical Director'
  };

  return (
    <Box
      {...rest}
      className={clsx(className)}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: 'fit-content'
      }}
    >
      <Avatar
        alt="Person"
        component={RouterLink}
        src={avatar}
        sx={{
          width: 60,
          height: 60
        }}
        to="/settings"
      />

      <Typography
        sx={{ mt: 1 }}
        variant="h4"
      >
        {user.name}
      </Typography>

      <Typography variant="body2">
        {user.bio}
      </Typography>
    </Box>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;